import Slider from 'react-rangeslider'
import PropTypes from 'prop-types'
import React,{useEffect,useRef} from 'react'

let CustomSlider = (props) =>{
  const sliderRef = useRef(null)
  const {setValue,initValue} = props
  useEffect(()=>{
    if(sliderRef.current){
      const {slider} = sliderRef.current
      const currentClassname = slider.className
      slider.className = currentClassname + " shades-primary-background-1-100"
      if(slider.children && slider.children.length){
        for (const item of slider.children) {
          if(item.className==="rangeslider__fill"){
            item.className = "rangeslider__fill primary-background-1-100"
          }
          if(item.className==="rangeslider__handle"){
            item.className = "rangeslider__handle primary-border-1-100"
          }
        }
      }
    }
  },[sliderRef])

  const initFlag = useRef(false)
  useEffect(()=>{
    if(initFlag.current === false){
      setValue(initValue)
      initFlag.current = true
    }
  },[setValue,initValue,initFlag])
  return (
    <Slider ref={sliderRef}
     {...props}
    />
  )
}

CustomSlider.propTypes = {
  setValue: PropTypes.func,
  initValue: PropTypes.any
}


export default CustomSlider